import React from 'react';

const ReturnRefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-100">
        <div className="p-4 sm:p-12">
          {/* Main Title - Standard Gray/Black as requested */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 border-b-2 border-gray-200 pb-4">
            Return & Refund Policy
          </h1>

          {/* Date Added Here */}
          <p className="text-sm text-gray-500 mb-8 italic font-medium">
            Update at 10/01/2026
          </p>

          <div className="text-gray-800 space-y-6 leading-relaxed text-base">
            
            {/* Intro */}
            <p>
              At <span className="font-bold">Regees Textile</span>, we aim to ensure a fair and transparent cancellation and refund process for our customers.
            </p>

            {/* Order Cancellation */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Order Cancellation
              </h2>
              <ul className="list-disc pl-5 space-y-2 mb-4">
                <li>
                  Customers may cancel their order <span className="font-bold">only before the order is processed or dispatched.</span>
                </li>
                <li>
                  Once the order has been <span className="font-bold">shipped or dispatched</span>, cancellation requests will <span className="font-bold">not be accepted</span>.
                </li>
              </ul>
              <p>
                To request a cancellation, customers must contact our support team immediately via email, phone, or through the website.
              </p>
            </div>

            {/* Refund Policy */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Refund Policy
              </h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Approved refunds will be processed <span className="font-bold">only to the original mode of payment</span> used during checkout (UPI, debit card, credit card, net banking via Razorpay).
                </li>
                <li>
                  <span className="font-bold">Cash refunds are not provided.</span>
                </li>
                <li>
                  Refunds will be initiated <span className="font-bold">after verification and approval</span> by the Company.
                </li>
              </ul>
            </div>

            {/* Refund Processing Time */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Refund Processing Time
              </h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Once approved, refunds will be processed within <span className="font-bold">5–10 business days</span>.
                </li>
                <li>
                  The credited amount may take additional time to reflect in your account depending on your bank or payment provider.
                </li>
              </ul>
            </div>

            {/* Non-Refundable Cases */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Non-Refundable Cases
              </h2>
              <p className="mb-4">
                Refunds will <span className="font-bold">not</span> be applicable in the following cases:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Orders cancelled after dispatch</li>
                <li>
                  Damage or issues not reported within <span className="font-bold">24 hours of delivery</span>
                </li>
                <li>Products returned in used, washed, or altered condition</li>
                <li>Minor color variations (2%–5%) due to lighting or screen resolution</li>
              </ul>
            </div>

            {/* Shipping & Tax Conditions */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Shipping & Tax Conditions
              </h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Shipping charges, if any, are <span className="font-bold">non-refundable</span> once the order is dispatched.
                </li>
                <li>
                  Customs duties, taxes, or government levies (if applicable) are <span className="font-bold">non-refundable</span>.
                </li>
              </ul>
            </div>

            {/* Company Rights */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Company Rights
              </h2>
              <p className="mb-2">The Company reserves the right to:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Reject refund requests that do not meet policy conditions</li>
                <li>Cancel orders due to stock unavailability, payment failure, pricing errors, or suspected fraud</li>
                <li>Modify this policy at any time without prior notice</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnRefundPolicy;